import React, {Component} from 'react';
import isMobile from "ismobilejs";

import {t} from 'l10n';

class RoomUserListItem extends Component {
    componentDidMount() {
        const {user: {video_preview}} = this.props;
        if (video_preview) {
            window.setInterval(this.checkBlur, 1000);
            if (isMobile.any) {
                window.addEventListener("scroll", this.checkVideoPosition())
            }
        }
        
    }
    
    checkVideoPosition = () => () => {
        const videoPosition = window.innerHeight - this.video.getBoundingClientRect().top;
        const pausePosition = window.innerHeight / 2 + this.video.getBoundingClientRect().height;
        const playPosition = window.innerHeight / 2;
    
        const shouldPlay = (videoPosition > playPosition) && (videoPosition < pausePosition);
        
        if (shouldPlay) {
            this.video.play();
        } else {
            this.video.pause();
        }
    };
    
    onContextMenu(event) {
        event.preventDefault();
        return false;
    }
    
    video = null;
    
    playPreview = e => {
        e.preventDefault;
        this.video.play();
    };
    
    stopPreview = e => {
        e.preventDefault;
        this.video.pause();
    };
    
    componentWillUnmount() {
        window.removeEventListener("scroll", this.checkVideoPosition);
    }
    
    render() {
        const {user, roomUrl, onItemClick} = this.props;
        const snapshot_url = (user.snapshot || user.avatar_url || '') + "?_=" + Math.floor(Date.now() / 60000);
        return (
            <div className="stretch-wrapper">
                <a
                    href={roomUrl}
                    style={{backgroundImage: 'url(' + snapshot_url + ')'}}
                    onClick={(event) => { onItemClick(event, roomUrl, user) }}
                >
                    {user.video_preview && (
                        <video
                            onMouseEnter={this.playPreview}
                            onMouseLeave={this.stopPreview}
                            onContextMenu={this.onContextMenu}
                            ref={ref => this.video = ref}
                            src={user.video_preview}
                            muted
                            loop
                            disablePictureInPicture
                            playsInline={true}
                        />
                    )}
                    <p>
                        <span>{t('ONLINE')}</span>
                        <small>{t('Blurred for privacy concerns.')}</small>
                    </p>
                </a>
            </div>
        )
    }
}

export default RoomUserListItem;


// WEBPACK FOOTER //
// ./src/components/index/RoomUserListItem.js